module.exports = __webpack_public_path__ + "img/cloud-wind-2-moon.691c10d1.svg";